import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "trade-container" }
const _hoisted_2 = { class: "trade-actions" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "trade-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["src", "onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "close-btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToDashboard && _ctx.goToDashboard(...args)))
    }, "✖ CLOSE"),
    _cache[6] || (_cache[6] = _createElementVNode("h2", null, "TRADES", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "add-trade win",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addNewTrade('Win')))
      }, "Add Win"),
      _createElementVNode("button", {
        class: "add-trade loss",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addNewTrade('Loss')))
      }, " Add Loss ")
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Chargement des trades..."))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trades, (trade) => {
        return (_openBlock(), _createElementBlock("div", {
          key: trade.id,
          class: "trade",
          onClick: ($event: any) => (_ctx.editTrade(trade.id))
        }, [
          (trade.imageUrls && trade.imageUrls.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trade.imageUrls, (image, index) => {
                  return (_openBlock(), _createElementBlock("img", {
                    key: index,
                    src: image,
                    class: "trade-img",
                    onClick: _withModifiers(($event: any) => (_ctx.openImage(image)), ["stop"]),
                    onMouseover: _cache[3] || (_cache[3] = ($event: any) => (_ctx.zoomImage($event))),
                    onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetZoom($event)))
                  }, null, 40, _hoisted_8))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, _toDisplayString(trade.note), 1),
          _createElementVNode("span", {
            class: _normalizeClass({
            win: trade.status === 'Win',
            loss: trade.status === 'Loss',
          })
          }, _toDisplayString(trade.status), 3),
          _createElementVNode("button", {
            class: "delete-btn",
            onClick: _withModifiers(($event: any) => (_ctx.handleDeleteTrade(trade.id)), ["stop"])
          }, " 🗑 Delete ", 8, _hoisted_9)
        ], 8, _hoisted_6))
      }), 128))
    ]),
    (_ctx.zoomedImage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "lightbox",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeImage && _ctx.closeImage(...args)))
        }, [
          _createElementVNode("img", {
            src: _ctx.zoomedImage,
            class: "fullsize-img"
          }, null, 8, _hoisted_10)
        ]))
      : _createCommentVNode("", true)
  ]))
}